import React, { Component } from 'react';
import {createMarkup} from './Factory'; 
import {UISref} from 'ui-router-react';

class Presse extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
	}
	handleClick(){
		let {title,publication_price:price} = this.props;
		this.props.handleClick(title.rendered,price);
	}
	render(){		
		let {post_title:title,start_date:start,end_date:end,image,image_title,image_alt,slug,pagetype} = this.props;
		let imgUrl = image;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}
		
		let post_date = start;
		if(end)
			post_date = start+"-"+end;
		let go_state = '';
		if(pagetype==='ausstellungen')
			go_state = "root.presse.ausstellungendetails";
		else
			go_state = "root.presse.neuigkeitendetails";
		return(
			<UISref to={go_state} params={{item:slug}}>
				<a>
					<div className="press-item clearfix">						
						<div title={image_title} className="ratio-presse thumb" style={divStyle}>
							<img src={image} alt={image_alt} title={image_title} />
						</div>
						<div className="info">
							<h1 className="h2" dangerouslySetInnerHTML={createMarkup(title)}></h1>
							<time dateTime="">{post_date}</time>
						</div>
					</div>
				</a>
			</UISref>		
		)
	}	
}
export default Presse;


// WEBPACK FOOTER //
// ./src/components/Presse.js